import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { IdleTimerProvider } from "../components/idle/IdleTimerProvider";
import { isValidRedirectPath } from "../components/configure/utils";

export default function PrivateRoute({ children }) {
  const { pathname } = useLocation();
  const { inProgress } = useMsal();
  const currentPath = window.location.pathname;
  const redirectPath = isValidRedirectPath(currentPath) ? currentPath : "/";
  sessionStorage.setItem("sd_redirect", redirectPath);

  return (
    <>
      <AuthenticatedTemplate>
        {inProgress === "none" ? <IdleTimerProvider>{children}</IdleTimerProvider> : pathname !== "/sign-in" ? <Navigate to="/sign-in" replace /> : null}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Navigate to="/sign-in" replace />
      </UnauthenticatedTemplate>
    </>
  );
}
